"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.messages = react_intl_1.defineMessages({
    firstInstallment: {
        defaultMessage: '<label>erste Rate</label><value>{data}</value>',
        id: 'installment-calculator.first-installment',
    },
    fixedMonthlyInterestFactor: {
        defaultMessage: '<label>Fixer Sollzinssatz pro Monat</label><value>{data}</value>',
        id: 'installment-calculator.fixed-monthly-interest-factor',
    },
    installmentSurcharge: {
        defaultMessage: '<label>Ratenaufschlag**</label><value>{data}</value>',
        id: 'installment-calculator.installment-surcharge',
    },
    lastInstallment: {
        defaultMessage: '<label>letzte Rate</label><value>{data}</value>',
        id: 'installment-calculator.last-installment',
    },
    monthlyInterestRateFactor: {
        defaultMessage: '<label>Ratenaufschlag pro Monat**</label><value>{data}</value>',
        id: 'installment-calculator.monthly-interest-rate-factor',
    },
    overallPriceRVC: {
        defaultMessage: '<label>Ratenpreis</label><value>{data}</value>',
        id: 'installment-calculator.overall-price-rvc',
    },
    paymentPauseSurcharge: {
        defaultMessage: '<label>Zinsaufschlag für Zahlpause</label><value>{data}</value>',
        id: 'installment-calculator.paymentpause-surcharge',
    },
    singleInstallmentRVC: {
        defaultMessage: '<label>Monatliche Mindestrate</label><value>{data}</value>',
        id: 'installment-calculator.single-installment-rvc',
    },
    yearlyInterestRateFactor: {
        defaultMessage: '<label>Effektiver Jahreszins</label><value>{data}</value>',
        id: 'installment-calculator.yearly-interest-factor',
    },
});
exports.default = exports.messages;
//# sourceMappingURL=messages.js.map